module.exports = __webpack_public_path__ + "img/checkin_1.af43675c.png";